<template>
  <div class="table-responsive">
    <div class="custom-listing" :style="listingHeight">
      <z-table
        v-model="records"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :sort-by="sortBy"
        :order-by="orderBy"
        :columns="tableColumnsName"
        :detail-column-class="detailColumnClass"
      >
        <template #tbody="props">
          <td class="custom-column-200">{{ formatDate(props.row.createdOn) }}</td>
          <td>{{ props.row.firmName }}</td>
          <td class="custom-column-200">{{ props.row.ronumber }}</td>
          <td class="custom-column-200">{{ props.row.invoiceNumber }}</td>
          <td>{{ props.row.vendorName }}</td>
          <td>{{ props.row.status }}</td>
          <td scope="row" class="custom-column-120">{{ props.row.invoice }}</td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
</template>
<script>
import { Parser } from '@json2csv/plainjs'
import globals from '@/plugins/globals'
import moment from 'moment'
import ZTable from '@/components/utilities/elements/Table.vue'
export default {
  name: 'TransactionListing',
  components: {
    ZTable
  },
  props: {
    transactions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isHeaderFixed: true,
      sortBy: 'createdOn',
      orderBy: 'desc',
      detailColumnClass: 'custom-column-60'
    }
  },
  computed: {
    tableColumnsName() {
      let columns = [
        { field: 'createdOn', label: 'Date', sortable: false, class: 'custom-column-200' },
        { field: 'firmName', label: 'Location', sortable: false },
        { field: 'ronumber', label: 'RO #', sortable: false, class: 'custom-column-200' },
        { field: 'invoiceNumber', label: 'Invoice #', sortable: false, class: 'custom-column-200' },
        { field: 'vendorName', label: 'Vendor', sortable: false },
        { field: 'status', label: 'Status', sortable: false },
        {
          field: 'invoice',
          label: 'Id',
          sortable: false,
          class: 'custom-column-120'
        }
      ]
      return columns
    },
    records() {
      let _records = []
      if (this.transactions) {
        _records = this.transactions
      }
      return _records
    }
  },
  methods: {
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    download() {
      try {
        if (this.transactions === null) {
          return
        }
        if (this.transactions.length === 0) {
          return
        }
        const parser = new Parser()
        const csv = parser.parse(this.transactions)
        let now = moment().format('YYYY-MM-DD')
        console.log(csv)
        // download the file as CSV
        var downloadLink = document.createElement('a')
        var blob = new Blob(['\ufeff', csv])
        var url = URL.createObjectURL(blob)
        downloadLink.href = url
        downloadLink.download = `Invoice Transactions ${now}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 70vh;
  height: 70vh;
}
</style>
